module.exports = __webpack_public_path__ + "img/9788925556116.b40c1e0e.jpg";